import * as React from "react";
import {RouteComponentProps} from "react-router-dom";
import {connect} from "react-redux";
import {IReduxState} from "reducers";
import {clearinitiationNachError, initialNach} from "consent/actions";
import {IDocAppointment, INach, IOppSubstatus, IPhysicalDocs, IRepaymode} from "StateInterface";
import {handleRepayNavigation, RepayRoutePaths} from "consent/repayment/route";
import {setAndroidTokenAndVersionBeforeRedirecting} from "utils/android";
import {getIdToken} from "service";
import {consentAndroidRedirect, consentWebAppRedirect, imageBaseUrl, nachRazorpayRedirectionUrl, razorpayKey} from "config";
import ConsentBox from "consent/utils/consentBox";
import OptionCard from "components/optionCard";
import ErrorHandle from "consent/repayment/errorHandle";
import {partnerOfferings} from "login/config";
import {loadGoogleScript} from "login/gapiLogin";

export enum RePayMode {
  eNACH ,
  Scan ,
  Appointment,
}

interface IConnectProps {
  userId: number;
  oppId: string;
  rePayModes: IRepaymode[];
  subStatuses: string[];
  dispatch?: (action: any) => void;
  enachLink: string;
  pnachLink: string;
  initiationNachError: string;
  isAndroid: boolean;
  apiVersion: number;
  utm_source: string;
  isPartnerAndroid: boolean;
  nach: INach;
}

interface IState {
  currentPath: string;
}

class RepaymentOptions extends React.Component<IConnectProps & RouteComponentProps, IState> {
  private rePayModeButtons = {
    eNACH: {
      name: RePayMode.eNACH,
      value: "E - NACH",
      description: "Register E-NACH via Net Banking / Debit Card",
    },
    Scan: {
      name: RePayMode.Scan,
      value: "Scan & Upload",
      description: "Download NACH form, sign & upload it",
    },
  };
  constructor(props) {
    super(props);
    this.state = {
      currentPath: this.props.location.pathname,
    };
    this.handleOnBtnClick = this.handleOnBtnClick.bind(this);
    this.handleENach = this.handleENach.bind(this);
  }
  public handleENach(enachLink: string) {
    if (this.props.isAndroid) {
      setAndroidTokenAndVersionBeforeRedirecting(this.props.apiVersion, getIdToken());
    }
    window.open(enachLink, "_self");
  }
  public componentWillReceiveProps(nextProps): void {
    if (!this.props.enachLink && nextProps.enachLink && nextProps.nach?.vendor === "LOTUSPAY") {
      this.handleENach(nextProps.enachLink);
    }

    if (!this.props.nach?.vendor && nextProps?.nach?.vendor && nextProps?.nach?.vendor === "RAZORPAY") {
      loadGoogleScript("https://checkout.razorpay.com/v1/checkout.js", () => {
        const options = {
          key: razorpayKey,
          order_id: nextProps.nach.order_id,
          customer_id: nextProps.nach.customer_id,
          recurring: "1",
          callback_url: nachRazorpayRedirectionUrl,
          notes: {
            receipt: this.props.oppId,
          },
        };
        const rzp1 = new (window as any).Razorpay(options);
        if (this.props.isAndroid) {
          setAndroidTokenAndVersionBeforeRedirecting(this.props.apiVersion, getIdToken());
        }
        rzp1.open();
      });
    }
  }

  public handleOnBtnClick(repayMode) {
    switch (repayMode) {
      case RePayMode[RePayMode.eNACH] : {
          if (!this.props.enachLink) {
            let redirectUrl;
            if (this.props.isAndroid && !this.props.isPartnerAndroid) {
              redirectUrl = consentAndroidRedirect;
            } else {
              redirectUrl = consentWebAppRedirect;
            }
            this.props.dispatch(initialNach(this.props.oppId, "ENACH", redirectUrl));
          } else {
            this.handleENach(this.props.enachLink);
          }
          break;
      }
      case RePayMode[RePayMode.Scan] : {
        handleRepayNavigation(`${this.state.currentPath}${RepayRoutePaths.SCAN}`, {parent: this.state.currentPath});
        break;
      }
    }
  }
  public sortFunciton(a: {mode: string}, b: {mode: string}) {
    return RePayMode[a.mode] - RePayMode[b.mode];
  }
  public renderRePayModesSelection() {
    let repayModes = this.props.rePayModes;
    if (repayModes) {
      repayModes = repayModes.map((ele) => ele.mode);
      if (repayModes.length > 1 && repayModes.includes(RePayMode[RePayMode.Appointment])
        && !this.props.subStatuses.includes(IOppSubstatus.KYC_PENDING)) {
        repayModes =  repayModes.filter((mode) => (mode !== "Appointment"));
      }
      repayModes.sort(this.sortFunciton);
      return (
        <div>
          {repayModes.map((rePaymode) => {
            return(
                <OptionCard
                     icon={partnerOfferings[this.props.utm_source] ? partnerOfferings[this.props.utm_source]?.optionCardIcon : undefined}
                     key={rePaymode}
                     primaryText={this.rePayModeButtons[rePaymode].value}
                     secondaryText={this.rePayModeButtons[rePaymode].description}
                     onClick={() => this.handleOnBtnClick(rePaymode)}/>
            );
          })}
        </div>
      );
    }
  }

  public onErrorMsgClose() {
    this.props.dispatch(clearinitiationNachError());
  }

  public render() {
    return(
        <ConsentBox pageTitle="Select Repayment Mode">
          {this.renderRePayModesSelection()}
          {this.props.initiationNachError &&
            <ErrorHandle
              errorMsg={this.props.initiationNachError}
              onCloseHandler={() => this.onErrorMsgClose()}
              repaymentModes={this.props.rePayModes}
            />}
        </ConsentBox>
    );
  }
}

const mapStateToProps = (state: IReduxState): IConnectProps => {
  const loanApprovalInfo = state.consent.loanApprovalInfo;
  return {
    userId: state.login.auth.userId,
    oppId: state.consent.lenderOpportunityId ? state.consent.lenderOpportunityId : null,
    rePayModes: state.consent.consentProcessMode ? state.consent.consentProcessMode.processModes.Repayment : null,
    subStatuses : state.consent.loanApprovalInfo.subStatuses,
    initiationNachError: state.consent.initiationNachError,
    enachLink : state.consent.loanApprovalInfo.nach ? state.consent.loanApprovalInfo.nach.enachAuthLink : null,
    nach: state.consent?.loanApprovalInfo?.nach,
    pnachLink: loanApprovalInfo && loanApprovalInfo.nach ? loanApprovalInfo.nach.pnachLink : null,
    isAndroid: state.login.isAndroid,
    isPartnerAndroid: state.login.isPartnerAndroid,
    apiVersion: state.login.apiVersion,
    utm_source: state.login.authExt ? state.login.authExt.utm_source : null,
  };
};

export default connect<IConnectProps, {}, {}>(mapStateToProps)(RepaymentOptions);
